import { createReducer, on } from '@ngrx/store';
import * as searchAllClinicalReviewsActions from 'src/app/clinical/store/actions';
import { ClinicalReviewSubmittalStatus } from '../../review-queue/models/clinical-review-submittal-status.model';

export interface SearchAllClinicalReviewsState {
    clinicalSubmittalStatuses: ClinicalReviewSubmittalStatus[];
    error?: string;
    exception?: unknown;
}

export const initialState: SearchAllClinicalReviewsState = {
    clinicalSubmittalStatuses: null
};

export const searchAllClinicalReviewsReducer = createReducer(
    initialState,
    on(
        searchAllClinicalReviewsActions.loadClinicalSubmittalStatuses,
        (state): SearchAllClinicalReviewsState => ({
            ...state
        })
    ),

    on(
        searchAllClinicalReviewsActions.loadClinicalSubmittalStatusesSuccess,
        (state, action): SearchAllClinicalReviewsState => ({
            ...state,
            clinicalSubmittalStatuses: action.clinicalSubmittalStatuses
        })
    ),

    on(
        searchAllClinicalReviewsActions.loadClinicalSubmittalStatusesFailed,
        (state, action): SearchAllClinicalReviewsState => ({
            ...state,
            error: action.error,
            exception: action.exception
        })
    ),
);
